import { useState } from "react";
import { navLinks, siteName } from "@/mocks/campus";
import SearchBox from "./SearchBox";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const close = () => setMenuOpen(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 md:px-6">
        {/* 品牌（首页 H1 包裹 Logo） */}
        <h1 className="flex items-center gap-2.5 text-foreground-950">
          <a href="#top" className="flex items-center gap-2.5" aria-label={`${siteName} 首页`}>
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 font-heading text-lg text-background-50 shadow-lift">瓜</span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl tracking-wide">{siteName}</span>
              <span className="mt-1 hidden text-[10px] font-medium tracking-[0.2em] text-primary-600 sm:block">CAMPUS GOSSIP PICK</span>
            </span>
          </a>
        </h1>

        {/* 桌面导航 */}
        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.anchor}
              href={`#${link.anchor}`}
              onClick={close}
              className="rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <div className="hidden w-52 md:block xl:w-60">
            <SearchBox />
          </div>
          <a
            href="#hot"
            className="hidden items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line text-base" />
            围观热榜
          </a>
          {/* 移动端菜单按钮 */}
          <button
            type="button"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {/* 移动端菜单面板 */}
      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="mb-3">
            <SearchBox autoFocus={false} />
          </div>
          <nav className="flex flex-col gap-1" aria-label="移动端主导航">
            {navLinks.map((link) => (
              <a
                key={link.anchor}
                href={`#${link.anchor}`}
                onClick={close}
                className="rounded-xl px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#hot"
            onClick={close}
            className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-fire-line text-base" />
            围观今日热榜
          </a>
        </div>
      ) : null}
    </header>
  );
}